import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import { Layout, Menu, Button, Tooltip, Typography, Spin, Image } from "antd";
import "./backbone.css";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  UserOutlined,
  HomeOutlined,
  BookOutlined,
  FormOutlined,
  CopyOutlined,
  EditOutlined,
} from "@ant-design/icons";
import queryString from "query-string";
import {
  fetchAuth,
  deleteToken,
  retriveToken,
} from "../../services/AuthServices";
import Alert from "../common/alert";
// import icons from "../../assets/sidebarIcons"

import { login, changeActiveRoute } from "../../reducers/loggedinuser.js";
// import { changeActiveRoute } from "../../actions/useraction";
import { getActiveRoute } from "../trainee/utils";

import AllTrainer from "../admin/allTrainer/alltrainer";
import AllStudent from "../admin/allStudent/allstudent";
import Student from "../trainee/students/student";
import AllTopics from "../admin/allTopics/alltopics.js";
import AllQuestions from "../trainer/allquestions/allquestion";
import AllTests from "../trainer/alltests/alltest";
import StudentHistorey from "../trainee/studentHistorey/studentHistorey";
import AllStudentTest from "../trainee/alltest/allStudentTest";
import ConductTest from "../trainer/conducttest/conducttest";
import NewTest from "../trainer/newtest/newtest";
import Welcome from "./welcome";
import ErrorPage from "./errorPage";
import Profile from "../trainee/profile/Profile";
import EditProfile from "../trainee/profile/EditProfile/EditProfile";
import Statistics from "../trainee/statistics/Statistics";
import QuesConsulation from "../trainee/QuestionConsultation/QuesConsulation";
import QuestionConsultation from "../trainer/questionconsultation/QuestionConsultation";
import ClaimReward from "../trainee/claimrewards/ClaimReward.js";
import AllRewards from "../admin/rewards/AllRewards.js";
import AllActiveOrder from "../admin/activeOrder/AllActiveOrder.js";
import AllPastOrder from "../admin/pastOrder/AllPastOrder.js";
import Badges from "../trainee/Badges/Badges.js";

import SiderImage from "../../assets/sideImage.svg";
import SiderLogo from "../../assets/leagueonlinelogo.svg";
import main from "./main.png";
import { toggleNavigation } from "../../reducers/opendrawer.js";
import { iconMap } from "../../assets/sidebarIcons/iconMap.js";

const { Header, Sider, Content } = Layout;

const getIconComponent = (iconName) => {
  switch (iconName) {
    case "home":
      return <HomeOutlined />;
    case "user":
      return <UserOutlined />;
    case "book":
      return <BookOutlined />;
    case "form":
      return <FormOutlined />;
    case "copy":
      return <CopyOutlined />;
    case "edit":
      return <EditOutlined />;
    default:
      return null;
  }
};

const Dashboard = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const drawer = useSelector((state) => state.drawer.navigationCollapsed);
  //  console.log(auth);

  const { options } = useParams();
  // console.log(options);

  const location = useLocation();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [localLoggedIn, setLocalLoggedIn] = useState(auth.isLoggedIn);

  const toggle = () => {
    dispatch(toggleNavigation());
  };

  const logOut = () => {
    deleteToken();
    window.location.href = "/";
  };

  // useEffect(() => {
  //   const token = retriveToken();

  //   // If token is missing or invalid, redirect to login
  //   if (!token || token === "undefined") {
  //     window.location.href = "/";
  //     return;
  //   }

  //   // If user is not yet logged in locally, fetch auth
  //   if (!localLoggedIn) {
  //     fetchAuth(token)
  //       .then((res) => {
  //         const userData = res.data;
  //         console.log(userData);

  //         dispatch(login(userData));
  //         setLocalLoggedIn(true);

  //         // Get current path after /user/
  //         const path = window.location.pathname.split("/").pop();
  //         const userOptions = userData?.userOptions || [];

  //         // Try to match the current path to a user option
  //         const activeRouteIndex = userOptions.findIndex((opt) =>
  //           opt.link.endsWith(path)
  //         );

  //         if (activeRouteIndex === -1) {
  //           // No match, redirect to first valid link
  //           const fallbackLink = userOptions[0]?.link;
  //           window.location.href = fallbackLink;
  //         } else {
  //           // Valid route found
  //           dispatch(changeActiveRoute(String(activeRouteIndex)));
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Auth fetch failed:", err);
  //         deleteToken();
  //         Alert("error", "Error!", "Session expired. Please log in again.");
  //         window.location.href = "/";
  //       });
  //   }
  // }, [dispatch, localLoggedIn]);

  useEffect(() => {
    const token = retriveToken();

    if (localLoggedIn) return;

    if (token && token !== "undefined") {
      fetchAuth(token)
        .then((response) => {
          dispatch(login(response.data.user));
          setLocalLoggedIn(true);

          const path = location.pathname.split("/").pop();
          const activeRouteIndex = getActiveRoute(path);
          if (activeRouteIndex === -1) {
            navigate(auth?.userOptions[0].link);
          } else {
            dispatch(changeActiveRoute(String(activeRouteIndex)));
          }
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.message
            : error.message;
          Alert("error", "Error!", message);
          deleteToken();
          navigate("/");
        });
    } else {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!auth?.userOptions?.length) return;

    const obj = auth.userOptions.find((o) => o.link === `/user/${options}`);
    const index = auth.userOptions.indexOf(obj);
    if (index === -1) {
      navigate(auth.userOptions[0].link);
    } else {
      dispatch(changeActiveRoute(String(index)));
    }
  }, [options, auth.userOptions, dispatch, navigate]);

  const renderComponent = () => {
    switch (options) {
      case "listtrainers":
        return <AllTrainer />;
      case "liststudents":
        return <AllStudent />;
      case "students":
        return <Student />;
      case "listsubjects":
        return <AllTopics />;
      case "rewards":
        return <AllRewards />;
      case "badges":
        return <Badges />;
      case "activeorders":
        return <AllActiveOrder />;
      case "pastorders":
        return <AllPastOrder />;
      case "listquestions":
        return <AllQuestions />;
      case "listtests":
        return <AllTests />;
      case "questionconsultation":
        return <QuestionConsultation />;
      case "testHistory":
        return <StudentHistorey />;
      // return <AllStudentTest />;
      case "livetest":
        return <AllStudentTest />;
      case "profile":
        return <Profile />;
      case "statistics":
        return <Statistics />;
      case "claimRewards":
        return <ClaimReward />;
      case "profileSettings":
        return <EditProfile />;
      case "questionConsultation":
        return <QuesConsulation />;
      case "home":
        return <Welcome />;
      case "newtest":
        return <NewTest />;
      case "conducttest":
        const params = queryString.parse(location.search);
        return <ConductTest {...params} />;
      default:
        return <ErrorPage />;
    }
  };

  if (!auth.isLoggedIn) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  const isStudent = auth.user.type === "STUDENT";

  return (
    <div>
      {isStudent ? (
        <>
          <Sider
            trigger={null}
            theme="light"
            width={250}
            collapsedWidth={0}
            collapsible
            collapsed={screenWidth < 860 && !drawer}
            style={{
              overflow: "hidden",
              height: "100vh",
              position: "fixed",
              left: 0,
              zIndex: 30,
              top: 0,
              background:
                "linear-gradient(180deg, #020202 0%, rgba(59, 64, 70, 0) 100%)",
            }}
          >
            <div className="siderToggle">
              <MenuFoldOutlined
                onClick={toggle}
                style={{ color: "#fff", fontSize: "20px", padding: "20px" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100vh",
              }}
            >
              <div
                style={{
                  paddingTop: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img width="80%" src={SiderLogo} alt="logo" />
                </div>

                <Menu
                  selectedKeys={[auth?.activeRoute]}
                  mode="inline"
                  theme="dark"
                  style={{ background: "transparent", color: "white" }}
                  items={auth?.userOptions.map((d, i) => ({
                    key: i,
                    icon: d.icon.endsWith(".svg") ? (
                      <img
                        width="15px"
                        style={{ filter: "invert(1)", marginRight: 6 }}
                        src={iconMap[d.icon]}
                        alt=""
                      />
                    ) : (
                      getIconComponent(d.icon)
                    ),
                    label: (
                      <Link
                        to={d.link}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <span>{d.display}</span>
                      </Link>
                    ),
                  }))}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                <img width="100%" src={SiderImage} alt="bottom visual" />
              </div>
            </div>
          </Sider>

          <div 
          style={{position:'absolute',top:0, right:0,left:0, bottom:0, overflow:'hidden'}}
          >
            <Layout
              style={{
                marginLeft: screenWidth >= 860 ? 250 : !drawer ? 0 : 250,
              }}
            >
              <Content
                style={{ height: "100vh", transition: "margin-left 0.3s" }}
              >
                {screenWidth < 860 && !drawer && (
                  <div className="sideOpenIcon">
                    <MenuFoldOutlined
                      onClick={toggle}
                      style={{
                        color: "#fff",
                        fontSize: "20px",
                        padding: "10px",
                      }}
                    />
                  </div>
                )}

                {renderComponent()}
              </Content>
            </Layout>
          </div>
        </>
      ) : (
        <>
          <Sider
            trigger={null}
            collapsible
            collapsed={drawer}
            theme="light"
            style={{
              overflow: "hidden",
              height: "100vh",
              position: "fixed",
              left: 0,
              top: 0,
              zIndex: 30,
            }}
          >
            <div className="logo11" />
            <Menu
              defaultSelectedKeys={[auth?.activeRoute]}
              mode="inline"
              theme="light"
              items={
                auth?.userOptions?.map((d, i) => ({
                  key: String(i),
                  icon: getIconComponent(d.icon),
                  label: (
                    <Link
                      to={d.link}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <span>{d.display}</span>
                    </Link>
                  ),
                })) || []
              }
            />
          </Sider>
          <Layout>
            <Header
              style={{
                position: "fixed",
                top: 0,
                width: "100vw",
                paddingLeft: "10px",
                zIndex: "1000",
                background: "rgb(70, 93, 114)",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {drawer ? (
                <MenuUnfoldOutlined
                  onClick={toggle}
                  style={{ color: "#fff", fontSize: "20px", padding: "20px" }}
                  className="trigger"
                />
              ) : (
                <MenuFoldOutlined
                  onClick={toggle}
                  style={{ color: "#fff", fontSize: "20px", padding: "20px" }}
                />
              )}
              <ul className="user-options-list">
                <li>
                  <Tooltip title="Log Out">
                    <Button
                      type="primary"
                      size="large"
                      shape="circle"
                      onClick={logOut}
                      style={{ marginBottom: 20 }}
                    >
                      <LogoutOutlined />
                    </Button>
                  </Tooltip>
                </li>
                <li style={{ display: "flex", alignItems: "center" }}>
                  <img
                    style={{ padding: "5px" }}
                    src={main}
                    alt="company logo"
                    className="d-logo"
                  />
                </li>
              </ul>
            </Header>
            <Content
              style={{
                margin: "24px 16px",
                padding: 24,
                marginTop: "80px",
                background: "rgb(205,217,225)",
                minHeight: "80vh",
                marginLeft: "95px",
              }}
            >
              <div style={{ width: "100%" }}>{renderComponent()}</div>
            </Content>
          </Layout>
        </>
      )}
    </div>
  );
};

export default Dashboard;
